const paraBirimiData = [
    {
        id: 1,
        text: "TL"
    },
    {
        id: 2,
        text: "Euro"
    },
    {
        id: 3,
        text: "Dolar"
    }
]

const faturaTipiData = [
    {
        id: 1,
        text: "Satış",
        value: "SATIS"
    },
    {
        id: 2,
        text: "İade",
        value: "IADE"
    },
    {
        id: 3,
        text: "Tevkifat",
        value: "TEVKIFAT"
    },
]

const tevkifatData = [
    {
        text: "10"
    },
    {
        text: "20"
    },
    {
        text: "30"
    },
    {
        text: "40"
    },
    {
        text: "50"
    },
]

const kolayAdresData = [
    {
        id: 1,
        text: "Telefon"
    },
    {
        id: 2,
        text: "TC No"
    },
    {
        id: 3,
        text: "Vergi No"
    },
    {
        id: 4,
        text: "Pasaport No"
    },
    {
        id: 5,
        text: "Mail Adresi"
    },
]

const kdvData = [
    {
        text: "10"
    },
    {
        text: "20"
    },
    {
        text: "30"
    },
    {
        text: "40"
    },
    {
        text: "50"
    }, 
]

export {paraBirimiData, faturaTipiData, tevkifatData, kolayAdresData, kdvData}